import { render, staticRenderFns } from "./ProdutoCodigosVinculo.vue?vue&type=template&id=f7b5a86c&scoped=true&"
import script from "./ProdutoCodigosVinculo.vue?vue&type=script&lang=js&"
export * from "./ProdutoCodigosVinculo.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoCodigosVinculo.vue?vue&type=style&index=0&id=f7b5a86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b5a86c",
  null
  
)

export default component.exports